function nswReferralForm() {
  const toField = document.querySelector('[name=confirmation-email');
  const nameField = document.querySelector('[name=confirmation-name');
  const referralType = document.querySelector('[name=self-referral]');
  const clientEmail = document.querySelector('[name=client-email]');
  const clientName = document.querySelector('[name=first-name]');
  const referrerEmail = document.querySelector('[name=referrer-email]');
  const referrerName = document.querySelector('[name=referrer-first-name]');

  if (!toField) {
    return;
  }

  const isSelfReferral = function () {
    return referralType.value === 'Self';
  };

  const updateEmail = function () {
    if (isSelfReferral()) {
      toField.value = clientEmail.value;
    } else {
      toField.value = referrerEmail.value;
    }
  };

  const updateName = function () {
    if (isSelfReferral()) {
      nameField.value = clientName.value;
    } else {
      nameField.value = referrerName.value;
    }
  };

  referralType.addEventListener('change', updateEmail);
  referralType.addEventListener('change', updateName);
  clientEmail.addEventListener('change', updateEmail);
  referrerEmail.addEventListener('change', updateEmail);
  clientName.addEventListener('change', updateName);
  referrerName.addEventListener('change', updateName);
}

export function init() {
  nswReferralForm();
}
